import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { REPLACE_USER } from '../common/constants/reduxConstants'

export type PrivacyGuardOverride = {
  appointmentId: number
  on: boolean
}

type PrivacyGuardState = {
  /**
   * The provider's explicit privacy guard decision for a single appointment, or null when they
   * have not made one. Persisted (see the root persistConfig whitelist in store.ts) so the
   * decision survives a refresh, and takes precedence over the default of turning the guard on
   * once the session is active.
   *
   * Only one appointment is ever eligible for the join session banner at a time, so a single
   * record is enough. A record left over from a past appointment is inert, because the
   * appointmentId will not match.
   */
  override: PrivacyGuardOverride | null
}

const initialState: PrivacyGuardState = {
  override: null,
}

const privacyGuardSlice = createSlice({
  name: 'privacyGuard',
  initialState,
  reducers: {
    setPrivacyGuardOverride: (state, action: PayloadAction<PrivacyGuardOverride>) => {
      state.override = action.payload
    },
  },
  extraReducers: (builder) => {
    // A supervisor switching into another provider must not inherit that provider's decision.
    builder.addCase(REPLACE_USER, () => initialState)
  },
})

export const { setPrivacyGuardOverride } = privacyGuardSlice.actions
export default privacyGuardSlice.reducer
